import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "performance"
    }}>{`Performance`}</h1>
    <p>{`With every release, we did some work to improve the performance to get a better experience when users visit a cartsy site. But after installing the theme on your site, you won't get similar performance as our demo sites as we did some extra work on our demo sites, which improves the performance.`}</p>
    <p>{`In this section, we'll be discussing the thing you can do to your site to improve the performance like ours.`}</p>
    <h2 {...{
      "id": "server"
    }}>{`Server`}</h2>
    <p>{`A server makes a significant rule for performance, So make sure you get a proper server that can quickly handle your site without any connection drop or any processor power shortage.`}</p>
    <h2 {...{
      "id": "cdn"
    }}>{`CDN`}</h2>
    <p>{`To serve the content, you can use CDN, which will improve the performance of loading the content. `}<a parentName="p" {...{
        "href": "https://www.stackpath.com/products/cdn/"
      }}>{`https://www.stackpath.com/products/cdn/`}</a>{` can be an excellent option for CDN. You can use any CDN for your site.`}</p>
    <h2 {...{
      "id": "compress-images"
    }}>{`Compress Images`}</h2>
    <p>{`The image size can take so much time to load the site. To reduce the size, you can use the image compress plugin to your site, which will reduce the size of an image during the upload.`}</p>
    <p><a parentName="p" {...{
        "href": "https://wordpress.org/plugins/wp-smushit/"
      }}>{`https://wordpress.org/plugins/wp-smushit/`}</a>{` is a popular plugin to compress images, and you can use it on your site.`}</p>
    <h2 {...{
      "id": "redis"
    }}>{`Redis`}</h2>
    <p>{`Redis is an object cache plugin that reduces the query time after the first visit. You've to install Redis on your server first. Please contact your hosting provider to install Redis on your server. After installing Redis on the server, use the `}<inlineCode parentName="p">{`Redis Object Cache`}</inlineCode>{` plugin to use Redis on your WordPress site.`}</p>
    <p><a parentName="p" {...{
        "href": "https://wordpress.org/plugins/redis-cache/"
      }}>{`https://wordpress.org/plugins/redis-cache/`}</a></p>
    <h2 {...{
      "id": "cache-plugin"
    }}>{`Cache Plugin`}</h2>
    <p>{`Use this cache plugin to enable the browser label cache.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wordpress.org/plugins/autoptimize/"
        }}>{`https://wordpress.org/plugins/autoptimize/`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wordpress.org/plugins/wp-optimize/"
        }}>{`https://wordpress.org/plugins/wp-optimize/`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wordpress.org/plugins/wp-super-cache/"
        }}>{`https://wordpress.org/plugins/wp-super-cache/`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      